import { Instagram, Twitter } from "react-feather"

import { Link } from "~/components/Link"

type SocialLinkProps = {
  username: string
  iconSize?: number
}

export const TwitterLink = ({ iconSize, username }: SocialLinkProps) => {
  return (
    <Link
      key="twitter"
      href={`https://twitter.com/${username.replace("@", "")}`}
      isExternal
    >
      <Twitter aria-hidden size={iconSize} />
      <span className="sr-only">{username}</span>
    </Link>
  )
}

export const InstagramLink = ({ iconSize, username }: SocialLinkProps) => {
  return (
    <Link
      key="instagram"
      href={`https://www.instagram.com/${username.replace("@", "")}`}
      isExternal
    >
      <Instagram aria-hidden size={iconSize} />
      <span className="sr-only">{username}</span>
    </Link>
  )
}
